import { NutritionalInformationProps } from './types';
import {
  Body3,
  Box,
  Color,
  FontWeight,
  Heading5,
  Space,
  useTheme,
} from '@gousto-internal/citrus-react';

export function NutritionalInformation({ nutritionalInformation }: NutritionalInformationProps) {
  const { theme } = useTheme();

  const { per100g, perPortion } = nutritionalInformation;

  return (
    <Box>
      <Heading5>Nutritional Information*</Heading5>
      <Space size={2} />
      <table
        style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse' }}
        cellPadding={4}
      >
        <thead style={{ borderBottom: `1px solid ${theme.color(Color.ColdGrey_200)}` }}>
          <tr>
            <th>
              <Body3 fontWeight={FontWeight.Bold}>Typical values</Body3>
            </th>
            <th>
              <Body3 fontWeight={FontWeight.Bold}>per 100g</Body3>
            </th>
            <th>
              <Body3 fontWeight={FontWeight.Bold}>per Serving</Body3>
            </th>
          </tr>
        </thead>
        <tbody>
          <TableRow label="Energy" per100g={per100g.energyKj} perPortion={perPortion.energyKj} />
          <TableRow
            label=""
            per100g={per100g.energyKcal}
            perPortion={perPortion.energyKcal}
            divider
          />
          <TableRow label="Fat" per100g={per100g.fat} perPortion={perPortion.fat} />
          <TableRow
            label="of which saturates"
            per100g={per100g.fatOfWhichSaturates}
            perPortion={perPortion.fatOfWhichSaturates}
            divider
          />
          <TableRow
            label="Carbohydrate"
            per100g={per100g.carbohydrate}
            perPortion={perPortion.carbohydrate}
          />
          <TableRow
            label="of which sugars"
            per100g={per100g.carbohydrateOfWhichSugars}
            perPortion={perPortion.carbohydrateOfWhichSugars}
            divider
          />
          <TableRow label="Fibre" per100g={per100g.fibre} perPortion={perPortion.fibre} divider />
          <TableRow
            label="Protein"
            per100g={per100g.protein}
            perPortion={perPortion.protein}
            divider
          />
          <TableRow label="Salt" per100g={per100g.salt} perPortion={perPortion.salt} divider />
        </tbody>
      </table>
      <Space size={2} />
      <Body3>
        *Gousto’s nutritional information only applies to ingredients supplied by Gousto. The
        cooking process and additional ingredients added at home (listed under “Ingredients not
        included”) will affect total values.
      </Body3>
    </Box>
  );
}

function TableRow({
  label,
  per100g,
  perPortion,
  divider,
}: {
  label?: string;
  per100g: string;
  perPortion: string;
  divider?: boolean;
}) {
  const { theme } = useTheme();

  return (
    <tr style={divider ? { borderBottom: `1px solid ${theme.color(Color.ColdGrey_200)}` } : {}}>
      <td>
        <Body3>{label}</Body3>
      </td>
      <td>
        <Body3>{per100g}</Body3>
      </td>
      <td>
        <Body3>{perPortion}</Body3>
      </td>
    </tr>
  );
}
